<label><ng-content></ng-content></label>
<div class="label">
    <mat-slider
      [min]="min"
      [max]="max"
      step="1"
      (change)="onChange()"
      (blur)="onBlur()"
      (focus)="onFocus($event)"
      (wheel)="onWheel($event)"
      class="custom-slider">
      <input
        matSliderThumb
        [(ngModel)]="percent"
        (input)="onChange()">
    </mat-slider>
    <div class="line">
      <ms-form-field color="tree" class="percent-field">
        <ms-number-input
          [(ngModel)]="percent"
          [min]="min"
          [max]="max"
          (wheel)="onWheel($event)"
          (blur)="onBlur()"
          (focus)="onFocus($event)">
        </ms-number-input>
      </ms-form-field>
      <span class="percent">%</span>
    </div>
</div>
